import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import { AwardsList } from "../dto/profile-awards.dto";

@Injectable()
export class ProfileAwardsIntegratedApi {

  private service: string = '';
  private model: string = 'sf6s/awards';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(payload: AwardsList): Observable<any> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/profile-awards.api.ts